<script setup>
    import { useChannelsStore } from '@/stores/channels'

    const store = useChannelsStore()
    store.formStep = 2

    store.channel.name = store.channel?.name || 'Chat Interno'
    store.channel.type = store.channel.type || 'internalchat'
    store.channel.server_type = store.channel.server_type || 'internalchat'
    store.channel.user = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
</script>

<template>
    <div class="flex flex-col items-center align-center w-full">
        <div class="h-40 w-40 mx-auto mb-8 mt-2">
            <img
                alt="Logo do Chat Interno"
                src="@/assets/images/icons/internal-chat.png"
            >
        </div>

        <div class="h-96 dark:text-gray-300">
            <p class="text-sm">
                Com o Chat Interno você pode se comunicar com todos os atendentes em tempo real, à qualquer momento!
                Assim, você pode centralizar toda a comunicação de sua empresa, em um sistema auditável.
            </p>

            <h3 class="text-lg block mt-3 mb-1 font-medium">
                Vantagens em usar o Chat Interno
            </h3>

            <ul class="text-sm list-disc ml-8 mb-10">
                <li>Centralizar toda comunicação da sua empresa;</li>
                <li>Liberdade de enviar/receber mensagens de texto, multimídias e voz, de acordo com a LGPD;</li>
                <li>Crie grupos de comunicação, de acordo com os interesses empresariais;</li>
                <li>Audite 100% das conversas, para manter a comunicação empresarial nos eixos (em breve);</li>
                <li>Mantenha comunicação à qualquer local: via web ou pelo nosso app;</li>
            </ul>
        </div>
    </div>
</template>
